export { TranslationEditor } from './translation-editor';

export type { TranslationLocale, TranslationValue } from './types';
